import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import "../../../../../library/common/DialogBox.scss";
import "./submitConfirmationDialog.scss";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": { padding: theme.spacing(2) },
  "& .MuiDialogActions-root": { padding: theme.spacing(1) },
}));

const SubmitConfirmationDialog = ({
  summary,
  isDraft,
  onConfirm,
  onCancel,
}) => {
  const allRows = [
    { label: "Project Name", value: summary?.projectName, applies: true },
    { label: "Inspection Type", value: summary?.inspectionType, applies: true },
    {
      label: "Frequency",
      value: summary?.frequency,
      applies: !!summary?.frequencyApplies,
    },
    { label: "Inspection Name", value: summary?.inspectionName, applies: true },
  ];

  const rows = isDraft ? allRows.filter((row) => row.applies) : allRows;

  return (
    <div className="dialogBoxOver" data-testid="sw-submit-confirm-overlay">
      <BootstrapDialog
        open
        onClose={onCancel}
        aria-labelledby="sw-submit-confirm-title"
        className="dialogBoxContainer swSubmitConfirm"
        data-testid="sw-submit-confirm-dialog"
      >
        <DialogTitle
          id="sw-submit-confirm-title"
          className="dialog-title"
          sx={{ m: 0, p: 2 }}
        >
          {isDraft ? "Confirm Save As Draft" : "Confirm Inspection Submission"}
        </DialogTitle>
        <DialogContent className="modalParaContent">
          <p className="swSubmitConfirm__intro">
            {isDraft
              ? "Please review the details below before saving this inspection as a draft."
              : "Please review the details below before submitting this inspection."}
          </p>
          <dl className="swSubmitConfirm__list">
            {rows.map((row) => (
              <div className="swSubmitConfirm__row" key={row.label}>
                <dt className="swSubmitConfirm__label">{row.label}</dt>
                <dd
                  className="swSubmitConfirm__value"
                  data-testid={`sw-submit-confirm-${row.label
                    .replace(/\s+/g, "-")
                    .toLowerCase()}`}
                >
                  {row.value || "N/A"}
                </dd>
              </div>
            ))}
          </dl>
        </DialogContent>
        <DialogActions className="dialogConfirm">
          <Button
            onClick={onCancel}
            className="deleteno"
            data-testid="sw-submit-confirm-cancel-btn"
          >
            Cancel
          </Button>
          <Button
            autoFocus
            variant="outlined"
            onClick={onConfirm}
            className="deleteyes"
            data-testid="sw-submit-confirm-submit-btn"
          >
            {isDraft ? "Confirm Save As Draft" : "Confirm Submission"}
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default SubmitConfirmationDialog;
